import { render, staticRenderFns } from "./HomePage.v2.vue?vue&type=template&id=6572df03&scoped=true&"
import script from "./HomePage.v2.vue?vue&type=script&lang=js&"
export * from "./HomePage.v2.vue?vue&type=script&lang=js&"
import style0 from "./HomePage.v2.vue?vue&type=style&index=0&id=6572df03&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6572df03",
  null
  
)

export default component.exports